import React from 'react';
import styles from './OverviewTab.module.css';
import { TopRoute, CriticalIssue } from '../routeDensityTypes';

interface OverviewTabProps {
  topRoutes: TopRoute[];
  criticalIssues: CriticalIssue[];
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ topRoutes, criticalIssues }) => {
  return (
    <div className={styles.grid}>
      {/* Top Performing Routes */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>Top Performing Routes</h3>
          <p className={styles.cardSubtitle}>Highest density + revenue</p>
        </div>
        <div className={styles.routeList}>
          {topRoutes.map((route) => (
            <div key={route.id} className={styles.routeItem}>
              <div className={styles.routeLeft}>
                <div className={styles.checkIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <div>
                  <p className={styles.routeName}>{route.name}</p>
                  <p className={styles.routeArea}>{route.area}</p>
                </div>
              </div>
              <div className={styles.routeRight}>
                <p className={styles.routeRevenue}>{route.revenue}</p>
                <p className={styles.routeDensity}>Density: {route.density}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Critical Route Issues */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>Critical Route Issues</h3>
          <p className={styles.cardSubtitle}>Immediate redesign needed</p>
        </div>
        {criticalIssues.map((issue) => (
          <div key={issue.id} className={styles.issueBlock}>
            <div className={styles.issueHeader}>
              <div className={styles.issueLeft}>
                <div className={styles.alertIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                  </svg>
                </div>
                <div>
                  <p className={styles.issueName}>{issue.name}</p>
                  <p className={styles.issueArea}>{issue.area}</p>
                </div>
              </div>
              <div className={styles.issueRight}>
                <p className={styles.issueRevenue}>{issue.revenue}</p>
                <p className={styles.issueCost}>{issue.costLabel}</p>
              </div>
            </div>
            <ul className={styles.issueList}>
              {issue.issues.map((text, i) => (
                <li key={i} className={styles.issueItem}>{text}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
